import {SetUintTypeComponent} from './SetUintTypeComponent';

export default SetUintTypeComponent;
